import $ from 'jquery';
import modal from './modal'
import Cookies from 'js-cookie';
import templateHelper from './template-helper';

class Login {

  init() {
    this._renderHeader();
    this._cacheDom();
    this._bindEvents();

    // Show modal on init if it contains form errors
    // But not on login page itself (xzibit danger)
    if(this.$loginModal.find('.stage-error').length && $('.content .login-form').length === 0) {
      this._showLoginPrompt();
    }
  }

  _cacheDom() {
    this.$loginModal = $('#login');
    this.$loginButton = $('.js-login');
    this.$document = $(document);
    this.$redirectInput = $('input[name="stage-extranet-from"]');
  }

  _bindEvents() {
    this.$document.ajaxComplete(function(event, xhr, settings) {

      if(typeof xhr.responseJSON !== 'undefined' && xhr.responseJSON.status === 'FAILED') {
        // Not logged in
        if(xhr.status === 401) {
          this._showLoginPrompt();
        }
      }
    }.bind(this));

    this.$loginButton.on('click', function(ev) {
      ev.preventDefault();
      this._showLoginPrompt();
    }.bind(this));

  }

  _showLoginPrompt() {
    modal.openModal(this.$loginModal);
    this.$redirectInput.val(window.location.href);
  }

  /**
   * Checks if user is logged in.
   *
   * @returns {boolean} True if user is logged in, false if not.
   */
  _userIsLoggedIn() {
    return !!Cookies.get('svt-extranet-username');
  }

  /**
   * Checks if user is a dismantler.
   * WARNING: This is just a frontend check.
   * A backend check is also needed to verify this.
   * Use this only to see if user is definitely not a dismantler.
   *
   * @returns {boolean} True if user is a dismantler, false otherwise.
   */
  userIsDismantler() {
    return String(Cookies.get('svt-extranet-is-dismantler')) === 'true';
  }


  /**
   * Checks if user is a greenline dismantler.
   * WARNING: This is just a frontend check.
   * A backend check is also needed to verify this.
   * This is just used to show button correctly on main page. On greenline page there is a different check for user roles
   *
   * @returns {boolean} True if user is a greenline dismantler, false otherwise.
   */
  userIsGreenlineDismantler() {
    return String(Cookies.get('svt-extranet-is-greenline-dismantler')) === 'true';
  }

  /**
   * Renders the part of the header that depends on user's login status.
   *
   * @param {boolean} user If true, renders in-logged user content.
   */
  _renderHeader(user = this._userIsLoggedIn()) {
    templateHelper.render('headerActionsDesktop', { user }, $('#header-actions-desktop'));
    templateHelper.render('headerActionsMobile', { user }, $('#header-actions-mobile'));
  }
}

module.exports = new Login();
